
import './App.css';
import Main from './component/Main';


function App() {
  return (
  <>
  <Main/>
  </>
   
  );
}

export default App;
